import Request from '../../lib/exchange/request'
import RequestTypes from '../../lib/exchange-api/request-types'

class AddUserRequest extends Request {
    constructor(username, login, pass_hash) {
        super({
            req: RequestTypes.ADD_USER,
            req_id: 0,
            user_name: username,
            login: login,
            pass_hash: pass_hash
        });
    }
}

export default AddUserRequest;